
import { v4 as uuidv4 } from 'uuid';
import { types } from '../types/types';
import { fetchConToken } from '../../helpers/fetch';
import { initialAddTitles, initialAddItems, initialDuplicateItems, initialCalculoTotales, initialCalItemByLine } from '../../helpers/items'
import { initialCreateBudgetNew, initialCreateBudgetDuplicate, initialCreateBudgetNewFromCrm } from '../../helpers/pptos'
import { checkValidationStatus } from '../../helpers/pptosProfits'

import { startOpenProgress } from '../actions/general'

import { toast } from 'react-toastify'

export const iniCargarPptos = (filters, { signal } = {}) => {
    return async (dispatch) => {

        try {
            const params = (new URLSearchParams(filters)).toString()
            const resp = await fetchConToken(`budgets/?${params}`, undefined, 'GET', { signal });
            const body = await resp.json();
            if (resp.ok && body.ok && !signal?.aborted) {
                dispatch(budgetsLoadList(body.data));
                return body;
            }

        } catch (error) {
            if (error.name !== 'AbortError') console.log(error)
        }

    }
}

export const iniCargarNegocios = (filters, { signal } = {}) => {
    return async (dispatch) => {

        try {
            const params = (new URLSearchParams(filters)).toString()
            const resp = await fetchConToken(`budgets/business/all/?${params}`, undefined, 'GET', { signal })
            const body = await resp.json()

            if (resp.ok && body.ok && !signal?.aborted) {
                dispatch(budgetsLoadList(body.data.budgets))
                dispatch(budgetsLoadTotalesLista(body.data.totales))
                return body;
            }

        } catch (error) {
            if (error.name !== 'AbortError') console.log(error)
        }

    }
}

export const iniLoadBudgetsDetail = (budgetId) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const resp = await fetchConToken(`budgets/${budgetId}`)
            const body = await resp.json()

            if (body.ok) {
                dispatch(budgetsLoadDetail(body.data))
                localStorage.setItem('budget-detail-init-data', JSON.stringify(body.data))
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(true))
        }
    }
}

export const iniLoadBudgetsDetailFromVersion = (infoVersion) => {
    return async (dispatch) => {
        try {

            const dataVersionPpto = JSON.parse(infoVersion.data_version)

            const newDataVersionPpto = {
                ...dataVersionPpto,
                restore_version: true,
                nro_version_actual: infoVersion.numero_version || 0
            }

            dispatch(startOpenProgress(true))
            dispatch(budgetsLoadDetail(newDataVersionPpto))
            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(true))
        }
    }
}

export const iniAddTitle = () => {
    return async (dispatch) => {
        try {
            const newIdTitle = uuidv4();
            const newItem = await initialAddTitles(newIdTitle);
            dispatch(budgetsAddItem(newItem));
        } catch (error) {
            console.log(error)
        }
    }
}

export const iniAddTitleWithItems = () => {
    return async (dispatch, getState) => {
        try {

            const newIdTitle = uuidv4();
            const newItem = await initialAddTitles(newIdTitle);
            dispatch(budgetsAddItem(newItem));

            const items = getState().ppto.detail.items
            const sorting = items.length
            dispatch(iniAddItem(newIdTitle, items, sorting, null, 0));

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniAddItem = (idTitle, items, sorting, data = null, categoryId) => {
    return async (dispatch, getState) => {
        try {

            const newId = uuidv4()
            const cantDefault = parseFloat(getState().ppto.detail?.area_construida || 0)

            let newData = data
            if (cantDefault > 0) {
                newData = {
                    ...newData,
                    cant: cantDefault,
                    unidad_medida: 'M2'
                }
            }

            const newItem = await initialAddItems({
                newId,
                idTitle,
                sorting,
                data: newData,
                categoryId
            })

            const newItems = items.map(item => {
                if (item.id === idTitle) {
                    return {
                        ...item,
                        items: [...item.items, newItem]
                    };
                }
                return item;
            });

            dispatch(budgetsLoadItems(newItems));

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniDuplicateItem = (items, item, detail) => {
    return async (dispatch, getState) => {
        try {
            const newId = uuidv4();
            let newItem = initialDuplicateItems(item, newId);

            if (item.tipo === 'title') {
                newItem.items = newItem.items.map(it => {
                    const newIdItem = uuidv4();
                    return {
                        ...it,
                        'id': newIdItem,
                        'index': newIdItem,
                        'id_titulo': newId,
                        'creado': false
                    };
                });

                dispatch(budgetsAddItem(newItem));

            } else {

                const newItems = items.map(it => {
                    if (it.id === item.id_titulo) {
                        return {
                            ...it,
                            items: [...it.items, newItem]
                        };
                    }
                    return it;
                });

                // actualiza total titulo
                const updatedTitles = newItems.map(title => {
                    if (title.id === item.id_titulo) {
                        const titleUpdatedAmounts = totalTitles(title.items)

                        return {
                            ...title,
                            ...titleUpdatedAmounts
                        };

                    }

                    return title;
                });

                dispatch(budgetsLoadItems(updatedTitles));

            }

            const newItemsUpdate = getState().ppto.detail.items
            const newTotales = await initialCalculoTotales(detail, newItemsUpdate);
            dispatch(budgetsUpdateTotales(newTotales));


        } catch (error) {
            console.log(error)
        }
    }
}

export const iniRemoveItem = (items, item, detail) => {
    return async (dispatch) => {
        try {

            const id = item.id;

            if (item.tipo === 'title') {
                const newItemsList = items.filter(item => item.id !== id);
                dispatch(budgetsLoadItems(newItemsList));

                const newTotales = await initialCalculoTotales(detail, newItemsList);
                dispatch(budgetsUpdateTotales(newTotales));

            } else {

                const newItemsList = items.map(title => {
                    if (title.id === item.id_titulo) {
                        const newItems = title.items.filter(it => it.id !== item.id);

                        const titleEnd = totalTitles(newItems)
                        return {
                            ...title,
                            ...titleEnd,
                            items: newItems
                        };
                    }
                    return title;
                });

                dispatch(budgetsLoadItems(newItemsList));

                const newTotales = await initialCalculoTotales(detail, newItemsList);
                dispatch(budgetsUpdateTotales(newTotales));

            }

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniCreateBudget = (from = null, infoOpor = null) => {
    return async (dispatch, getState) => {
        try {

            const initialParams = getState().general.detail

            const newInitial = {
                ...initialParams,
                uid: getState().auth.uid,
                info_crm: infoOpor
            }

            const rules = getState().general.rules
            let newDetail = null

            if (from === 'crm') {
                newDetail = await initialCreateBudgetNewFromCrm(newInitial, rules)
            } else {
                newDetail = await initialCreateBudgetNew(newInitial, rules)
            }

            dispatch(budgetsLoadDetail(newDetail))

        } catch (error) {
            console.log(error);
            toast.error(error)
        }
    }
}

export const iniCreateBudgetDuplicate = (currentData) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const newDetail = await initialCreateBudgetDuplicate(currentData)
            dispatch(budgetsLoadDetail(newDetail))

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(true))
        }
    }
}

export const iniSaveBudget = (detailBudget, navigate) => {
    return async (dispatch, getState) => {
        try {

            dispatch(startOpenProgress(true))

            const resp = await fetchConToken('budgets', detailBudget, 'POST');
            const body = await resp.json();
            if (body.ok) {

                if (body.ok) {
                    toast.success(body.msg);

                    const newIds = {
                        id: body.data.id,
                        numero: body.data.numero
                    }

                    dispatch(budgetsSetNewIds(newIds));
                    navigate(`/ppto/${body.data.id}`)

                } else {
                    toast.warning(body.msg);
                }
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniUpdateBudget = (detailBudget, idBudgeUpdate) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const { id } = detailBudget;

            console.log('--detailBudget.porcentaje_impuesto iniUpdateBudget--', detailBudget.porcentaje_impuesto)

            const resp = await fetchConToken(`budgets/${id}`, detailBudget, 'PUT')
            const body = await resp.json()

            if (body.ok) {
                if (id) {
                    dispatch(iniLoadBudgetsDetail(id))
                }
                toast.success(body.msg);
            } else {
                toast.warning(body.msg);
            }

            setTimeout(() => {
                dispatch(startOpenProgress(false))
            }, 5000)

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniCloseBudget = (id, newStatus) => {
    return async (dispatch,) => {
        try {

            dispatch(startOpenProgress(true))

            const dataForm = {
                id,
                status: newStatus
            }

            const resp = await fetchConToken(`budgets/close/${id}`, dataForm, 'PUT')
            const body = await resp.json()

            if (body.ok) {
                if (id) {
                    dispatch(iniLoadBudgetsDetail(id))
                }
                toast.success(body.msg);
            } else {
                toast.warning(body.msg);
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniUpdateBudgetModeTemplate = (newDetailUpdated) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const { template_id, referencia } = newDetailUpdated

            const newDataForm = {
                nombre: referencia,
                detalle_plantilla: newDetailUpdated
            }

            const resp = await fetchConToken(`templates/${template_id}`, newDataForm, 'PUT')
            const body = await resp.json()

            if (body.ok) {
                dispatch(budgetsLoadDetail(newDetailUpdated))
                toast.success(body.msg);
            } else {
                toast.warning(body.msg);
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}


// export const iniSaveTemplate = (budgetId, newIsTemplate) => {
//     return async (dispatch, getState) => {
//         try {

//             dispatch(startOpenProgress(true))

//             const dataForm = { is_template: newIsTemplate }
//             const resp = await fetchConToken(`budgets/templates/update/${budgetId}`, dataForm, 'PUT')
//             const body = await resp.json()

//             if (body.ok) {
//                 dispatch(setIsTemplate(newIsTemplate))
//                 toast.info(body.msg)
//             } else {
//                 toast.info(body.msg)
//             }

//             dispatch(startOpenProgress(false))

//         } catch (error) {
//             console.log(error)
//             toast.error(error)

//             dispatch(startOpenProgress(false))
//         }
//     }
// }

export const iniChangeItems = (items, target, values, index) => {
    return async (dispatch) => {
        try {
            const newItems = items.map(item => {
                if (item.index === index) {
                    let newItem = item;
                    const floatValue = values.floatValue;
                    if (target === 'cant') newItem.cant = floatValue;
                    if (target === 'dias') newItem.dias = floatValue;
                    if (target === 'precio_unitario') newItem.precio_unitario = floatValue;
                    if (target === 'costo_unitario') newItem.costo_unitario = floatValue;
                    const subTotalPrecio = newItem.cant * newItem.dias * newItem.precio_unitario;
                    const subTotalCosto = newItem.cant * newItem.dias * newItem.costo_unitario;
                    const totalRentabilidad = subTotalPrecio - subTotalCosto;
                    const margenRentabilidad = (totalRentabilidad / subTotalPrecio) * 100;
                    newItem.precio_subtotal = subTotalPrecio;
                    newItem.costo_subtotal = subTotalCosto;
                    newItem.margen_monto = totalRentabilidad;
                    newItem.margen_porcentaje = margenRentabilidad;
                    return newItem;
                }
                return item;
            });

            dispatch(budgetsLoadItems(newItems));

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniChangeItemsInside = (items, target, values, item, margen_sobre_costo = null) => {
    return async (dispatch) => {
        try {

            const titleFound = items.filter(t => t.id === item.id_titulo);
            // manera correcta ==> Precio = Coste / (1 - %margen)

            if (titleFound) {
                const newItems = items.map((title) => {
                    if (title.id === titleFound[0].id) {

                        const newItems_ = title.items.map(it => {
                            if (it.id === item.id) {
                                let newItem = it;
                                const floatValue = values.floatValue;
                                if (target === 'cant') newItem.cant = floatValue;
                                if (target === 'dias') newItem.dias = floatValue;
                                if (target === 'precio_unitario') newItem.precio_unitario = floatValue;
                                if (target === 'costo_unitario') newItem.costo_unitario = floatValue;
                                if (target === 'descuento') newItem.descuento = floatValue;

                                console.log({ target })

                                if (target !== 'margen_porcentaje') {

                                    // from costo
                                    if (target === 'costo_unitario' && newItem.margen_porcentaje && newItem.margenPorcentajeStatic) {

                                        if (margen_sobre_costo) {

                                            // Margen sobre Costo
                                            const factorMasUno = (parseFloat(newItem?.margen_porcentaje) / 100) + 1
                                            newItem.precio_unitario = parseFloat(newItem?.costo_unitario || 0) * factorMasUno

                                        } else {

                                            // Margen sobre Precio - (por defecto)
                                            newItem.precio_unitario = parseFloat(parseFloat((newItem.costo_unitario || 0) / (1 - (newItem.margen_porcentaje / 100))).toFixed(2))

                                        }

                                        const preSubTotalPrecio = newItem.cant * newItem.dias * newItem.precio_unitario;
                                        const subTotalPrecio = preSubTotalPrecio - newItem.descuento;
                                        const subTotalCosto = newItem.cant * newItem.dias * newItem.costo_unitario;

                                        newItem.pre_subtotal_precio = parseFloat(parseFloat(preSubTotalPrecio).toFixed(2));
                                        newItem.precio_subtotal = parseFloat(parseFloat(subTotalPrecio).toFixed(2));
                                        newItem.costo_subtotal = parseFloat(parseFloat(subTotalCosto).toFixed(2));
                                        newItem.margen_monto = (parseFloat(parseFloat((subTotalPrecio - subTotalCosto)).toFixed(2)) || 0);
                                        console.log('---from costos---', newItem.margen_monto)

                                    } else {

                                        // from precio venta
                                        const resultCalItems = initialCalItemByLine('precio_venta', newItem)
                                        newItem.pre_subtotal_precio = resultCalItems.pre_subtotal_precio
                                        newItem.precio_subtotal = resultCalItems.precio_subtotal
                                        newItem.costo_subtotal = resultCalItems.costo_subtotal
                                        newItem.margen_monto = resultCalItems.margen_monto
                                        newItem.margen_porcentaje = resultCalItems.margen_porcentaje
                                        console.log('---from ventas---', newItem.margen_monto)
                                    }
                                }
                                else {

                                    // from margen
                                    if (floatValue) newItem.margenPorcentajeStatic = true
                                    else newItem.margenPorcentajeStatic = false
                                    newItem.margen_porcentaje = floatValue;

                                    if (margen_sobre_costo) {

                                        // Margen sobre Costo
                                        const factorMasUno = (parseFloat(newItem?.margen_porcentaje) / 100) + 1
                                        newItem.precio_unitario = parseFloat(newItem?.costo_unitario || 0) * factorMasUno

                                    } else {

                                        // Margen sobre Precio - (por defecto)
                                        newItem.precio_unitario = parseFloat(parseFloat((newItem.costo_unitario || 0) / (1 - (newItem.margen_porcentaje / 100))).toFixed(2))

                                    }

                                    const preSubTotalPrecio = newItem.cant * newItem.dias * newItem.precio_unitario;
                                    const subTotalPrecio = preSubTotalPrecio - newItem.descuento;
                                    const subTotalCosto = newItem.cant * newItem.dias * newItem.costo_unitario;

                                    newItem.pre_subtotal_precio = parseFloat(parseFloat(preSubTotalPrecio).toFixed(2));
                                    newItem.precio_subtotal = parseFloat(parseFloat(subTotalPrecio).toFixed(2));
                                    newItem.costo_subtotal = parseFloat(parseFloat(subTotalCosto).toFixed(2));
                                    newItem.margen_monto = (parseFloat(parseFloat((subTotalPrecio - subTotalCosto)).toFixed(2)) || 0);

                                    console.log('---from margen---')
                                }

                                return newItem
                            }
                            return it;
                        });

                        const titleEnd = totalTitles([...newItems_], margen_sobre_costo)

                        return {
                            ...title,
                            ...titleEnd,
                            items: newItems_
                        };

                    }
                    return title;
                });

                dispatch(budgetsLoadItems(newItems));
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const iniChangeItemsInsideFromTitle = (newParams) => {
    return async (dispatch) => {
        try {

            const { items, new_margen, idTitulo, margen_sobre_costo = null } = newParams

            // console.log({ new_margen })

            const titleFound = items.filter(t => t.id === idTitulo)

            if (titleFound) {
                const newItems = items.map((title) => {

                    if (title.id === titleFound[0].id) {

                        const updatedTitleItems = title.items.map(it => {

                            let newItem = it
                            newItem.margen_porcentaje = new_margen

                            if (margen_sobre_costo) {

                                // Margen sobre Costo
                                const factorMasUno = (parseFloat(newItem.margen_porcentaje) / 100) + 1
                                newItem.precio_unitario = parseFloat(newItem?.costo_unitario || 0) * factorMasUno

                            } else {

                                // Margen sobre Precio - (por defecto)
                                newItem.precio_unitario = parseFloat(parseFloat((newItem?.costo_unitario || 0) / (1 - (newItem.margen_porcentaje / 100))).toFixed(2))

                            }

                            const preSubTotalPrecio = newItem.cant * newItem.dias * newItem.precio_unitario
                            const subTotalPrecio = preSubTotalPrecio - newItem.descuento
                            const subTotalCosto = newItem.cant * newItem.dias * newItem.costo_unitario

                            newItem.pre_subtotal_precio = parseFloat(parseFloat(preSubTotalPrecio).toFixed(2))
                            newItem.precio_subtotal = parseFloat(parseFloat(subTotalPrecio).toFixed(2))
                            newItem.costo_subtotal = parseFloat(parseFloat(subTotalCosto).toFixed(2))
                            newItem.margen_monto = (parseFloat(parseFloat((subTotalPrecio - subTotalCosto)).toFixed(2)) || 0)

                            return newItem

                        })

                        const titleEnd = totalTitles([...updatedTitleItems], margen_sobre_costo)

                        return {
                            ...title,
                            ...titleEnd,
                            items: updatedTitleItems
                        };

                    }

                    return title;
                })

                dispatch(budgetsLoadItems(newItems));
            }

        } catch (error) {
            console.log(error)
        }
    }
}

export const totalTitles = (items, margen_sobre_costo = null) => {
    try {

        const totalTitle = {
            cant: 0,
            dias: 0,
            precio_unitario: 0,
            precio_subtotal: 0,
            costo_unitario: 0,
            costo_subtotal: 0,
            margen_monto: 0,
            margen_porcentaje: 0,
            pre_subtotal_precio: 0,
            descuento: 0
        }

        items.map(newItem => {

            // const subTotalPrecio = newItem.cant * newItem.dias * newItem.precio_unitario;
            // const subTotalCosto = newItem.cant * newItem.dias * newItem.costo_unitario;

            const subTotalPrecio = newItem.precio_subtotal;
            const subTotalCosto = newItem.costo_subtotal;

            let totalRentabilidad = subTotalPrecio - subTotalCosto;
            if (totalRentabilidad < 0) {
                totalRentabilidad = 0;
            }

            // let margenRentabilidad = (totalRentabilidad / subTotalPrecio) * 100;
            let margenRentabilidad = 0

            if (margen_sobre_costo) {

                // Margen sobre Costo
                margenRentabilidad = (totalRentabilidad / subTotalCosto) * 100

            } else {

                // Margen sobre Precio - (por defecto)
                margenRentabilidad = (totalRentabilidad / subTotalPrecio) * 100
            }

            //console.log('--margenRentabilidad TETETE antes--', margenRentabilidad);
            if (margenRentabilidad === '- Infinity' || margenRentabilidad === -Infinity) {
                margenRentabilidad = 0;
            } else {
                margenRentabilidad = margenRentabilidad ? margenRentabilidad.toFixed(2) : 0;
            }

            //SumaTitle
            totalTitle.cant = (totalTitle.cant + newItem.cant)
            totalTitle.dias = (totalTitle.dias + newItem.dias)
            totalTitle.precio_unitario = (totalTitle.precio_unitario + newItem.precio_unitario)

            totalTitle.pre_subtotal_precio = parseFloat(parseFloat((totalTitle.pre_subtotal_precio + newItem.pre_subtotal_precio)).toFixed(2))
            totalTitle.descuento = parseFloat(parseFloat((totalTitle.descuento + newItem.descuento)).toFixed(2))

            // totalTitle.precio_subtotal = parseFloat(parseFloat((totalTitle.precio_subtotal + subTotalPrecio)).toFixed(2))

            totalTitle.precio_subtotal = parseFloat(parseFloat((totalTitle.precio_subtotal + + newItem.precio_subtotal)).toFixed(2))
            totalTitle.costo_unitario = (totalTitle.costo_unitario + newItem.costo_unitario)
            totalTitle.costo_subtotal = parseFloat(parseFloat((totalTitle.costo_subtotal + subTotalCosto)).toFixed(2))
            totalTitle.margen_monto = parseFloat(parseFloat((totalTitle.margen_monto + totalRentabilidad)).toFixed(2))
            totalTitle.margen_porcentaje = parseFloat(parseFloat((totalTitle.margen_porcentaje + parseFloat(margenRentabilidad))).toFixed(2))

            return newItem;

        });

        totalTitle.margen_porcentaje = totalTitle.margen_porcentaje / ((items.length === 0) ? 1 : items.length)

        return { ...totalTitle, margen_porcentaje: parseFloat(totalTitle.margen_porcentaje.toFixed(2)) }

    } catch (error) {
        return { error: true, message: error }
    }
}

export const iniChangeItemsName = (items, values, item) => {
    return async (dispatch, getState) => {
        try {

            const index = item.index;
            let newItems;
            if (item.tipo === 'title') {

                // verifica y titulo tiene items con servicio seleccionados
                const hasItems = (item?.items?.filter(it => parseFloat(it.id_servicio) > 0)).length > 0 ? true : false

                let itemListByCat = []
                if (!hasItems && parseInt(values.id_categoria) > 0) {
                    const servicesList = getState().general.services
                    const itemsFoundByCat = servicesList.filter(s => s.id_categoria === values.id_categoria)
                    const titleId = item.id

                    for (let x = 0; x < itemsFoundByCat.length; x++) {
                        const currentService = itemsFoundByCat[x]
                        const precioFromCatalogo = parseFloat(currentService?.precio_venta || 0)
                        const costoFromCatalogo = parseFloat(currentService?.precio_costo || 0)
                        const precioUnit = precioFromCatalogo
                        const costoUnit = costoFromCatalogo
                        const cant = 1
                        const dias = 1

                        // console.log('--currentService tetete--', currentService)

                        const resultCalItems = initialCalItemByLine('precio_venta', {
                            cant,
                            dias,
                            precio_unitario: precioUnit,
                            descuento: 0,
                            costo_unitario: costoUnit
                        })

                        const newData = {
                            id_servicio: currentService?.id_servicio || 0,
                            nombre: currentService?.nombre,
                            descripcion_larga: currentService?.descripcion_larga,
                            codigo: currentService?.codigo || '',
                            cant,
                            dias,
                            costo_unitario: costoUnit,
                            precio_unitario: precioUnit,
                            pre_subtotal_precio: resultCalItems.pre_subtotal_precio,
                            precio_subtotal: resultCalItems.precio_subtotal,
                            costo_subtotal: resultCalItems.costo_subtotal,
                            margen_monto: resultCalItems.margen_monto,
                            margen_porcentaje: resultCalItems.margen_porcentaje,
                            // descripcion_larga: currentService.descripcion
                        }

                        const newItem = await initialAddItems({
                            newId: uuidv4(),
                            idTitle: titleId,
                            sorting: (x + 1),
                            data: newData,
                            categoryId: values.id_categoria
                        })

                        itemListByCat = [
                            ...itemListByCat,
                            newItem
                        ]

                    }

                }

                newItems = items.map(item => {
                    if (item.index === index) {
                        if (!hasItems) {
                            const titleUpdatedAmounts = totalTitles(itemListByCat)
                            if (parseInt(values.id_categoria) > 0) {
                                return {
                                    ...item,
                                    'nombre': values.nombre,
                                    'id_categoria': values.id_categoria,
                                    'id_servicio': values.id_servicio,
                                    'id_titulo': values.id_titulo,
                                    items: itemListByCat,
                                    ...titleUpdatedAmounts
                                }
                            } else {
                                return {
                                    ...item,
                                    'nombre': values.nombre,
                                    'id_categoria': values.id_categoria,
                                    'id_servicio': values.id_servicio,
                                    'id_titulo': values.id_titulo
                                }
                            }
                        } else {
                            return {
                                ...item,
                                'nombre': values.nombre,
                                'id_categoria': values.id_categoria,
                                'id_servicio': values.id_servicio,
                                'id_titulo': values.id_titulo,
                            }
                        }
                    }

                    return item;

                });

            } else {

                const titleFound = items.find(t => t.id === item.id_titulo);
                if (titleFound) {

                    let hasTitleSelected = true
                    if (titleFound?.id_categoria === 0 || titleFound?.nombre === '') {
                        hasTitleSelected = false
                    }

                    newItems = items.map(title => {
                        if (title.id === titleFound?.id) {
                            const newIdCat = hasTitleSelected ? titleFound.id_categoria : values?.id_categoria
                            const newNameCat = hasTitleSelected ? titleFound.nombre : values?.categoria

                            const newItems_ = title.items.map(it => {
                                if (it.id === item.id) {
                                    return {
                                        ...it,
                                        ...values
                                    }
                                }
                                return it;
                            });

                            if (parseInt(values.id_servicio) > 0) {
                                const titleUpdatedAmounts = totalTitles(newItems_)
                                return {
                                    ...title,
                                    items: newItems_,
                                    id_categoria: newIdCat,
                                    nombre: newNameCat,
                                    ...titleUpdatedAmounts
                                }
                            } else {
                                return {
                                    ...title,
                                    items: newItems_
                                }
                            }


                        }

                        return title;

                    });
                }

            }

            dispatch(budgetsLoadItems(newItems))

            const detail = getState().ppto.detail
            const newTotales = await initialCalculoTotales(detail, newItems);
            dispatch(budgetsUpdateTotales(newTotales));

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniChangeDesLargaTitle = (items, values, item) => {
    return async (dispatch) => {
        try {

            const newItems = items.map(title => {
                if (title.id === item.id) {
                    // console.log('title found', title.id, item.id)
                    return {
                        ...title,
                        descripcion_larga: values.descripcion_larga,
                        id_proveedor: values.id_proveedor,
                        sin_impuesto: values.sin_impuesto,
                        descripcion_interna: values.descripcion_interna
                    };
                }

                return title
            });

            dispatch(budgetsLoadItems(newItems))

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniChangeDesLarga = (items, values, item) => {
    return async (dispatch) => {
        try {

            // const index = item.index;
            let newItems;

            const titleFound = items.filter(t => t.id === item.id_titulo);

            if (titleFound) {
                newItems = items.map(title => {
                    if (title.id === titleFound[0].id) {

                        const newItems_ = title.items.map(it => {
                            if (it.id === item.id) {
                                return {
                                    ...it,
                                    descripcion_larga: values.descripcion_larga,
                                    id_proveedor: values.id_proveedor,
                                    sin_impuesto: values.sin_impuesto,
                                    descripcion_interna: values.descripcion_interna
                                };
                            }
                            return it;
                        });

                        return {
                            ...title,
                            items: newItems_
                        };
                    }

                    return title;

                });
            }

            dispatch(budgetsLoadItems(newItems))

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniChangeTotales = (detail, items, margen_sobre_costo = null) => {
    return async (dispatch, getState) => {
        try {

            const newTotales = await initialCalculoTotales(detail, items, margen_sobre_costo);
            dispatch(budgetsUpdateTotales(newTotales))

            const rules = getState().general.rules.filter(it => it.habilitado === true)
            const hasRules = rules.length > 0 ? true : false
            const mangenPresupuestado = getState().ppto.detail?.margen_utilidad_p || 0
            console.log('--hasRules--', hasRules)

            if (hasRules) {
                const newStatus = await checkValidationStatus(mangenPresupuestado, rules)
                dispatch({
                    type: types.budgetsUpdateValidationStatus,
                    payload: newStatus
                })
            } else {
                dispatch({
                    type: types.budgetsUpdateValidationStatus,
                    payload: {
                        validacion_estado: '',
                        validacion_nota: '',
                        validacion_rentabilidad_optima: 0,
                        validacion_id_regla: 0,
                    }
                })
            }

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniBudgetPreview = () => {
    return async (dispatch) => {

        try {
            const resp = await fetchConToken('budgets');
            const body = await resp.json();
            if (body.ok) {
                /* console.log(body.data); */
                dispatch(budgetsLoadList(body.data));
            }

        } catch (error) {
            console.log(error)
        }

    }
}

export const iniShareBudget = () => {
    return async (dispatch) => {

        try {
            const resp = await fetchConToken('budgets');
            const body = await resp.json();
            if (body.ok) {
                /* console.log(body.data); */
                dispatch(budgetsLoadList(body.data));
            }

        } catch (error) {
            console.log(error)
        }

    }
}

export const iniChangeAllPpto = (detailBudget) => {
    return async (dispatch) => {
        try {
            dispatch(budgetsLoadDetail(detailBudget));
        } catch (error) {
            console.log(error);
        }
    }
}

/* approve */
export const iniApprovePpto = (budgetId, type) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const resp = await fetchConToken(`budgets/approve/${budgetId}`, { type }, 'PUT');
            const body = await resp.json()

            if (body.ok) {
                dispatch(iniLoadBudgetsDetail(budgetId))
                toast.success(body.msg)
            } else {
                toast.warning(body.msg)
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}
/* approve */

// anular
export const iniAnularPpto = (dataForm) => {
    return async (dispatch) => {
        try {

            const budgetId = dataForm.id
            dispatch(startOpenProgress(true))

            const resp = await fetchConToken(`budgets/anular/${budgetId}`, dataForm, 'PUT');
            const body = await resp.json()

            if (body.ok) {
                dispatch(iniLoadBudgetsDetail(budgetId))
                toast.success(body.msg)
            } else {
                toast.error(body.msg)
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}
// anular

/* -- validations */
export const iniValidateProfit = (budgetId, comments) => {
    return async (dispatch, getState) => {
        try {

            dispatch(startOpenProgress(true))

            const { uid } = getState().auth

            const dataForm = {
                id_validador: uid,
                comentario: comments
            }

            const resp = await fetchConToken(`budgets/validate/${budgetId}`, dataForm, 'PUT');
            const body = await resp.json()

            if (body.ok) {
                dispatch(iniLoadBudgetsDetail(budgetId))
                toast.success(body.msg)
            } else {
                toast.warning(body.msg)
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniRequestValidation = (budgetId) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const resp = await fetchConToken(`budgets/validate/request/${budgetId}`, {}, 'PUT');
            const body = await resp.json()

            if (body.ok) {
                dispatch(iniLoadBudgetsDetail(budgetId))
                toast.success(body.msg)
            } else {
                toast.warning(body.msg)
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniRestartValidation = (budgetId, comments) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const dataForm = {
                comentario: comments
            }

            const resp = await fetchConToken(`budgets/validate/restart/${budgetId}`, dataForm, 'PUT');
            const body = await resp.json()

            if (body.ok) {
                dispatch(iniLoadBudgetsDetail(budgetId))
                toast.success(body.msg)
            } else {
                toast.warning(body.msg)
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniRejectValidation = (budgetId, comments) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const dataForm = {
                comentario: comments
            }

            const resp = await fetchConToken(`budgets/validate/reject/${budgetId}`, dataForm, 'PUT');
            const body = await resp.json()

            if (body.ok) {
                dispatch(iniLoadBudgetsDetail(budgetId))
                toast.error(body.msg)
            } else {
                toast.warning(body.msg)
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}
/* -- validations */

/* initial services */
export const initAddInitialServices = (orderedItems) => {
    return async (dispatch) => {
        try {
            dispatch(budgetsLoadItems(orderedItems))
        } catch (error) {
            console.log(error)
        }
    }
}
/* initial services */

export const iniChangeItemsChecked = (items, checked, item) => {
    return async (dispatch) => {
        try {
            const titleFound = items.filter(t => t.id === item.id_titulo);
            if (titleFound) {
                const newItems = items.map(title => {
                    if (title.id === titleFound[0].id) {
                        const newItems_ = title.items.map(it => {
                            if (it.id === item.id) {
                                let newItem = it;
                                newItem.selected = checked;
                                return newItem;
                            }
                            return it;
                        });
                        return {
                            ...title,
                            items: newItems_
                        };
                    }
                    return title;
                })

                dispatch(budgetsLoadItems(newItems))
            }

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniChangeItemsUnidad = (items, valueUnidad, item) => {
    console.log('--valueUnidad tototo--', valueUnidad)
    return async (dispatch) => {
        try {
            const titleFound = items.filter(t => t.id === item.id_titulo);
            if (titleFound) {
                const newItems = items.map(title => {
                    if (title.id === titleFound[0].id) {
                        const newItems_ = title.items.map(it => {
                            if (it.id === item.id) {
                                let newItem = it;
                                newItem.unidad_medida = valueUnidad;
                                return newItem;
                            }
                            return it;
                        });
                        return {
                            ...title,
                            items: newItems_
                        };
                    }
                    return title;
                })

                dispatch(budgetsLoadItems(newItems))
            }

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniChangeItemsDate = (items, valueFecha, item) => {
    console.log('--fecha tototo--', valueFecha)

    return async (dispatch) => {
        try {
            const titleFound = items.filter(t => t.id === item.id_titulo);
            if (titleFound) {
                const newItems = items.map(title => {
                    if (title.id === titleFound[0].id) {
                        const newItems_ = title.items.map(it => {
                            if (it.id === item.id) {
                                let newItem = it;
                                newItem.fecha_inicio = valueFecha.name === 'fecha_inicio' ? valueFecha.value : newItem.fecha_inicio;
                                newItem.fecha_fin = valueFecha.name === 'fecha_fin' ? valueFecha.value : newItem.fecha_fin;
                                return newItem;
                            }
                            return it;
                        });
                        return {
                            ...title,
                            items: newItems_
                        };
                    }
                    return title;
                })

                dispatch(budgetsLoadItems(newItems))
            }

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniSaveItemsHide = (items, itemsSelected, status) => {
    return async (dispatch) => {
        try {

            console.log('--status--', status)

            let newTitles = items
            for (let x = 0; x < itemsSelected.length; x++) {
                let foundTitle = newTitles.find(t => t.id === itemsSelected[x].id_titulo)

                if (foundTitle) {
                    const newItems = foundTitle.items.map(it => {
                        if (it.id === itemsSelected[x].id) {
                            return {
                                ...it,
                                ocultar_item_print: status
                            }
                        }
                        return it
                    })

                    foundTitle.items = newItems

                    // si titulo tiene un item, tambien aplica cambio estado a titulo
                    foundTitle.ocultar_item_print = false
                    const cantItemOculto = foundTitle.items.filter(h => h.ocultar_item_print === true)
                    if (foundTitle.items.length === cantItemOculto.length) {
                        foundTitle.ocultar_item_print = status
                    }

                }

                newTitles = newTitles.map(title => {
                    if (title.id === itemsSelected[x].id_titulo) {
                        return foundTitle
                    }
                    return title
                })

            }

            dispatch(budgetsLoadItems(newTitles))

            if (status) {
                toast.success('Ítems ocultos!')
            } else {
                toast.success('Ítems visibles!')
            }

        } catch (error) {
            console.log(error)
        }
    }
}

// const setIsTemplate = (isTemplate) => ({
//     type: types.budgetsSetIsTemplate,
//     payload: isTemplate
// })

export const budgetsLoadDetail = (budgetsDetail) => ({
    type: types.budgetsLoadDetail,
    payload: budgetsDetail
})

export const budgetsLoadList = (pptos) => ({
    type: types.pptoCargarLista,
    payload: pptos
})

const budgetsLoadTotalesLista = (totales) => ({
    type: types.budgetsLoadTotalesLista,
    payload: totales
})

export const budgetsLoadItems = (itemList) => ({
    type: types.budgetsLoadItems,
    payload: itemList
})

const budgetsAddItem = (newItem) => ({
    type: types.budgetsAddItem,
    payload: newItem
})

export const budgetsUpdateTotales = (totales) => ({
    type: types.budgetsUpdateTotales,
    payload: totales
})

const budgetsSetNewIds = (newIds) => ({
    type: types.budgetsSetNewIds,
    payload: newIds
})

export const updateNewFolio = (newFolio) => ({
    type: types.budgetsUpdateNewFolio,
    payload: newFolio
})

export const budgetsUpdateDatosInicialesNotSave = (dataUpdate) => ({
    type: types.budgetsUpdateDatosInicialesNotSave,
    payload: dataUpdate
})

export const budgetsUpdateInfoFactNotSave = (dataUpdate) => ({
    type: types.budgetsUpdateInfoFactNotSave,
    payload: dataUpdate
})

export const budgetsUpdateColumnName = (dataUpdate) => ({
    type: types.budgetsUpdateColumnName,
    payload: dataUpdate
})

export const budgetsUpdateCondicionesNotSave = (dataUpdate) => ({
    type: types.budgetsUpdateCondicionesNotSave,
    payload: dataUpdate
})

export const budgetsUpdateProjections = (dataUpdate) => ({
    type: types.budgetsUpdateProjections,
    payload: dataUpdate
})

export const budgetsUpdateMontosFinalNotSave = (dataUpdate) => ({
    type: types.budgetsUpdateMontosFinalNotSave,
    payload: dataUpdate
})

export const budgetsSetFiltersList = (newFilters) => ({
    type: types.budgetsSetFiltersList,
    payload: newFilters
})

export const dashboardSetFiltersList = (newFilters) => ({
    type: types.dashboardSetFiltersList,
    payload: newFilters
})

export const orderDetailPpts = (pptoOrder) => {
    return async (dispatch) => {
        try {
            dispatch(budgetsLoadItems(pptoOrder));

        } catch (error) {
            console.log(error)
        }
    }
}
